import { render } from "./story_file_drop.vue?vue&type=template&id=e605f522&lang=pug"
import script from "./story_file_drop.vue?vue&type=script&lang=js"
export * from "./story_file_drop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__